import axios from "axios";
const url = process.env.REACT_APP_BASE_URL

export class Translate {
    static lang = "EN"
    storedDictionary: any = [];
    preferred_language = "en"

    constructor() {
        let localDistionary = localStorage.getItem('ivy_dict');
    
        this.storedDictionary = []
        // if (!localDistionary) {
        //     axios.get(url + '/translation/getdictionary.php').then((res) => {
        //         localStorage.setItem("ivy_dict", JSON.stringify(res?.data?.data?.data))
        //         window.location.reload()
        //     })
        // } else {
        // }

        let stored_preferred_lang = localStorage.getItem('preferred_lang');
        if (!stored_preferred_lang) {
            this.preferred_language = 'en'
        } else {
            this.preferred_language = stored_preferred_lang
        }
    }

    translateAuto() {

        setTimeout(() => {
            window.requestAnimationFrame(() => {

                // let allelements = document.querySelectorAll('*')
                let allelements = document.getElementsByTagName('a')
                for (let i = 0, max = allelements.length; i < max; i++) {
                    // Do something with the element here
                    let element = allelements[i]
                    let index = this.storedDictionary.findIndex((w: any) => w.word === element.textContent)
                    console.log(element.textContent, 'auto auto');

                    if (index !== -1 && this.preferred_language === "en") {
                        element.textContent = this.storedDictionary[index].EN
                    } else if (index !== -1 && this.preferred_language === "ar") {
                        element.textContent = this.storedDictionary[index].AR

                    } else {
                        return element.textContent;
                    }
                }


            })
        })
        // allelements.forEach((element: any) => {
        //     let index = this.storedDictionary.findIndex((w: any) => w.word === element.textContent)
        //     console.log(element.textContent);

        //     if (index !== -1 && this.preferred_language === "en") {
        //         element.textContent = this.storedDictionary[index].EN
        //     } else if (index !== -1 && this.preferred_language === "ar") {
        //         element.textContent = this.storedDictionary[index].AR

        //     } else {
        //         return element.textContent;
        //     }
        // })
    }


    translate(word: any) {

        let index = this.storedDictionary.findIndex((w: any) => w.keyword === word)
        if (index !== -1 && this.preferred_language === "en") {
            return this.storedDictionary[index].en
        } else if (index !== -1 && this.preferred_language === "ar") {
            return this.storedDictionary[index].ar
        } else {
            // axios.post(url + '/translation/addword.php', { keyword: word })
            return word;
        }
    }
}